export const isValidRegex = (v) => {
  if (!v) return false;
  try {
    // eslint-disable-next-line no-new
    new RegExp(v);
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};
